// Copyright (c) 2016 Deere & Company

import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import moment from 'moment';

export const getDefaultState = () =>
    new DateRange({
        from: moment.utc()
            .startOf('day')
            .valueOf(),
        max: moment.utc()
            .add(10, 'year')
            .endOf('day')
            .valueOf(),
        min: moment.utc()
            .subtract(12, 'month')
            .startOf('day')
            .valueOf(),
        to: moment.utc().add(90, 'day').endOf('day')
            .valueOf()
    });



// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/state/date-range.js